import { useNotification } from "@zapier/utils";
import {
  type Interface,
  useTransferInterface as useTransferInterfaceMutation,
} from "@zapier/client";

interface Input {
  interface: Interface | undefined;
  folderId?: string; // used for cache invalidation in mutations
}

export const useTransferInterface = ({
  interface: interfaceObject,
  folderId,
}: Input) => {
  const { createNotification } = useNotification();
  const { mutate, isPending } = useTransferInterfaceMutation({ folderId });

  const transferInterface = (newOwner: string | number) => {
    if (!interfaceObject?.id || !newOwner) {
      return;
    }

    mutate(
      { id: interfaceObject.id, ownerId: Number(newOwner) },
      {
        onSuccess: () => {
          createNotification({
            message: `Owner of “${interfaceObject.name}” changed successfully.`,
            type: "success",
          });
        },
        onError: () => {
          createNotification({
            message: `Unable to change owner of “${interfaceObject.name}”.`,
            type: "error",
          });
        },
      },
    );
  };

  return {
    transferInterface,
    isSubmitting: isPending,
  };
};
